<!-- Component can be used in microscope and periscope -->
<template>
  <div class="app-tabs-wrapper">
    <div class="app-tabs">
      <slot name="left" />

      <div class="spacer" />

      <slot name="right" />
    </div>
    <div v-if="isLoading" class="app-tabs-loading-bar" />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  isLoading?: boolean
}>()
</script>

<style lang="scss" scoped>
@keyframes loading-indeterminate {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(250%);
  }
}

.spacer {
  flex: 1;
}

.app-tabs-wrapper {
  position: sticky;
  top: var(--sticky-top, 0);
  z-index: 2;
  background-color: var(--app-tabs-bg, var(--color-canvas-muted, #f5f7fa));
  margin-bottom: 12px;
  border-bottom: 1.5px solid var(--color-border-default, #f3f4f5);
}

.app-tabs-loading-bar {
  position: relative;
  height: 1.5px;
  overflow: hidden;
  background-color: var(--color-accent-subtle, #b7d7ff);

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 40%;
    height: 100%;
    background-color: var(--color-accent-fg, #539bf5);
    animation: loading-indeterminate 1.2s ease-in-out infinite;
  }
}

.app-tabs {
  overflow-x: auto;
  gap: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: auto;
  margin-bottom: 4px;
  padding: 12px 0;

  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
